import { useAppDispatch, useAppSelector } from "@/app/appStore";
import Input from "@/components/input";
import { updateSeekAmount } from "@/entities/annotation";
import { Box } from "@radix-ui/themes";
import { useState, useEffect, useRef } from "react";

export function SeekAmount() {
  const dispatch = useAppDispatch();
  const seekAmount = useAppSelector((state) => state.annotation.seekAmount);
  const [localValue, setLocalValue] = useState(seekAmount);
  const skipBlurRef = useRef(false);

  useEffect(() => {
    setLocalValue(seekAmount);
  }, [seekAmount]);

  const handleSeekAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (!/^\d*\.?\d*$/.test(value)) {
      return;
    }

    if (value.startsWith("0") && !value.startsWith("0.") && value.length > 1) {
      return;
    }

    if (value.includes(".") && value.split(".")[1].length > 3) {
      return;
    }

    if (value === "" || (!isNaN(parseFloat(value)) && parseFloat(value) >= 0)) {
      setLocalValue(value);
    }
  };

  const handleSetValue = () => {
    if (skipBlurRef.current) {
      skipBlurRef.current = false;
      return;
    }

    const numValue = parseFloat(localValue);

    if (!localValue || isNaN(numValue) || numValue === 0) {
      setLocalValue(seekAmount);
      return;
    }

    const formattedValue = numValue.toFixed(3);
    dispatch(updateSeekAmount(formattedValue));
  };

  const handleCancel = () => {
    setLocalValue(seekAmount);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" || e.key === "Tab") {
      handleSetValue();
      e.currentTarget.blur();
    } else if (e.key === "Escape") {
      skipBlurRef.current = true;
      handleCancel();
      e.currentTarget.blur();
    }
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    e.currentTarget.select();
  };

  return (
    <Box>
      <Input
        type="text"
        name="seekAmount"
        label="Seek Amount(sec)"
        className="h-10 w-36"
        value={localValue}
        floatingLabel={false}
        placeholder="0.005"
        onChange={handleSeekAmountChange}
        onBlur={handleSetValue}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
      />
    </Box>
  );
}
